import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import ModalWrapper from "components/Modal";
import { UPDATE_BOOKING } from "apollo/mutations/booking";

const EditNotesModal = ({ isOpen, booking, onClose, onDone }) => {
  const [phone, setPhone] = useState(booking.customerPhone || "");
  const [notes, setNotes] = useState(booking.notes || "");
  const [errorText, setErrorText] = useState("");

  const [updateBooking, { loading: saving }] = useMutation(UPDATE_BOOKING);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await updateBooking({
        variables: {
          id: booking.id,
          input: {
            customerPhone: phone || null,
            notes: notes || null,
          },
        },
      });
      onDone?.();
    } catch (err) {
      setErrorText(err?.message || "Could not save changes.");
    }
  };

  return (
    <ModalWrapper modalIsOpen={isOpen} closeModal={onClose} isCloseIcon className="!max-w-[480px]">
      <form onSubmit={submit} className="px-4 py-4 sm:px-6 sm:py-2 font-[Montserrat]">
        <h2 className="text-[#2b364b] font-bold uppercase text-[24px] leading-tight">
          Edit Booking
        </h2>
        <p className="text-[12px] text-[#6b7280] mt-1">
          Update your phone or notes for the fitter.
        </p>

        <div className="mt-5 space-y-4">
          <div>
            <div className="text-[12px] text-[#2b364b] uppercase tracking-wide">Phone</div>
            <input
              className="w-full mt-1 px-4 h-[44px] rounded-[8px] border border-[#c3c9d4] text-[14px]"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div>
            <div className="text-[12px] text-[#2b364b] uppercase tracking-wide">
              Anything we should know?
            </div>
            <textarea
              className="w-full mt-1 px-4 py-2 h-[90px] rounded-[8px] border border-[#c3c9d4] text-[14px]"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>
          {errorText && <div className="text-[13px] text-[#f25022]">{errorText}</div>}
          <div className="flex gap-3 justify-center pt-2">
            <button
              type="button"
              onClick={onClose}
              className="w-[140px] h-[48px] rounded-full border border-[#2b364b] text-[#2b364b]"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="w-[160px] h-[48px] rounded-full bg-[#2b364b] text-white disabled:opacity-50"
            >
              {saving ? "Saving…" : "Save Changes"}
            </button>
          </div>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default EditNotesModal;
